import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import MeetingAddNewModal from './crudModals/MeetingAddNewModal';
import MeetingsCardBig from './MeetingsCardBig';
import MeetingsCard from './MeetingsCard';
// import { parse } from 'date-fns';
import { toast } from 'react-toastify';

const MeetingsComponent = ({ config }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [meetings, setMeetings] = useState([]);
    const [nextMeeting, setNextMeeting] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPageOptions, setItemsPerPageOptions] = useState([5, 10, 20]);
    const { user: authUser } = useSelector(x => x.auth);
    const url = process.env.REACT_APP_URL;

    useEffect(() => {
        if (config && Array.isArray(config.itemsPerPage) && config.itemsPerPage.length > 0) {
            setItemsPerPageOptions(config.itemsPerPage);
            setLimit(config.itemsPerPage[0]);
        }
    }, [config]);

    const getMeetings = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${url}/meetings?page=${page}&limit=${limit}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            setMeetings(data);

            setTotalPages(data.totalPages);
        } catch (error) {
            console.error('Error fetching meetings: ', error);
            toast.error(`Error fetching meetings: ${error.message}`, { position: 'bottom-left' });
        }
        setIsLoading(false);
    }, [url, limit, page]);

    const getNextMeeting = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${url}/meetings/comingup`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            setNextMeeting(data);
            setIsLoading(false);
        } catch (e) {
            console.log(`Meetings component - Next Meeting error: ${e}`);
            setIsLoading(false);
        }
    }, [url]);

    useEffect(() => {
        getMeetings();
        getNextMeeting();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit]);

    const handlePageChange = (newPage) => {
        console.log('Changing page to:', newPage);
        setPage(newPage);
    }

    const handleLimitChange = (e) => {
        setLimit(Number(e.target.value));
        setPage(1);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    if (isLoading) {
        return (
            <section className="meetings" id="meetings">
                <Spinner animation="border" variant="danger" />
            </section>
        );
    } else {
        return (
            <section className="meetings" id="meetings">
                <Container>
                    <Row className='header mt-3 mb-3'>
                        <Col xs={12} lg={6} className='title'><h3>All Meetings</h3></Col>
                        {(authUser && authUser.user.acl === 'Officer') &&
                            <Col xs={12} lg={6} key={'newMeeting'}>
                                <MeetingAddNewModal getMeetings={getMeetings} config={config} />
                            </Col>
                        }
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={12} lg={12}>
                            <Form.Control
                                type="text"
                                placeholder="Search for a meeting..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                                data-bs-theme={'dark'}
                            />
                        </Col>
                    </Row>
                    <Row>
                        {meetings.length === 0 ? (
                            <Col>
                                <p className="text-center">No meetings added yet</p>
                            </Col>
                        ) : (
                            <>
                                {/* {console.log('Meetings:', meetings)} */}
                                {/* {console.log('Next Meeting:', nextMeeting)} */}
                                {meetings.data.map(meeting => (
                                    meeting._id === nextMeeting?._id ? (
                                        <MeetingsCardBig meeting={meeting} getMeetings={getMeetings} key={meeting._id} />
                                    ) : (
                                        <MeetingsCard meeting={meeting} getMeetings={getMeetings} key={meeting._id} />
                                    )
                                ))
                                }
                            </>
                        )
                        }
                    </Row>
                    <Row>
                        <Col>
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => handlePageChange(1)}
                                disabled={page <= 1}
                            >
                                <i className="bi bi-chevron-double-left"></i>
                            </button>
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => handlePageChange(page - 1)}
                                disabled={page <= 1}
                            >
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            <span>Page {page} of {totalPages}</span>
                            <button
                                className="btn btn-secondary ms-2"
                                onClick={() => handlePageChange(page + 1)}
                                disabled={page >= totalPages}
                            >
                                <i className="bi bi-chevron-right"></i>
                            </button>
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => handlePageChange(totalPages)}
                                disabled={page >= totalPages}
                            >
                                <i className="bi bi-chevron-double-right"></i>
                            </button>
                        </Col>
                        <Col xs="auto">
                            <Form.Select value={limit} onChange={handleLimitChange} data-bs-theme={'dark'}>
                                {itemsPerPageOptions.map(opt => (
                                    <option key={opt} value={opt}>{opt}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="text-center mt-3">
                                Total meetings: {meetings?.data ? meetings.total : 0}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
};

export default MeetingsComponent;